import NewDesign from 'components/NewDesign';
import React from 'react';
import JSXCode from '../../Components/JSXCode';
import { Form, Formik } from 'formik';
import { CommonIcons } from 'components/Icons';
import { SIZE_ICON } from 'consts/data';
import FormikFields from 'components/FormikFields';

const TabForm = () => {
  return (
    <div className='component:TabForm'>
      <Formik
        initialValues={{
          name: '',
          gender: '',
          level: [],
          group: 'groupA',
          dateRange: { from: '', to: '' },
          date: '',
        }}
        onSubmit={() => {}}
      >
        {({ values, resetForm }) => {
          return (
            <Form>
              <NewDesign.Typography className='tw-text-2xl tw-mb-2' component='p'>
                Form Example
              </NewDesign.Typography>

              <div className='tw-flex tw-flex-col tw-gap-2'>
                <code className='tw-rounded-md tw-border tw-p-2'>{JSON.stringify(values)}</code>

                <FormikFields.Input name='name' label='Name' placeholder='Name' />
                <FormikFields.Select
                  name='gender'
                  placeholder='Select Gender'
                  label='Gender'
                  options={[
                    { label: 'Male', value: 'male' },
                    { label: 'Female', value: 'female' },
                  ]}
                  isClearable
                />
                <FormikFields.Select
                  name='level'
                  placeholder='Select Level'
                  label='Level'
                  options={[
                    { label: 'Senior', value: 'senior' },
                    { label: 'Middle', value: 'middle' },
                    { label: 'Junior', value: 'junior' },
                  ]}
                  isClearable
                  isMulti
                  closeMenuOnSelect={false}
                />

                <FormikFields.Checkbox name='isAdmin' label='Is Admin?' />

                <NewDesign.Typography>Group: </NewDesign.Typography>
                <div className='tw-flex tw-gap-6 default-border tw-p-2'>
                  <FormikFields.Radio
                    name='group'
                    id='group-1'
                    label='Group A'
                    valueRadio='groupA'
                  />
                  <FormikFields.Radio
                    name='group'
                    id='group-2'
                    label='Group B'
                    valueRadio='groupB'
                  />
                </div>
                <div className='tw-w-max'>
                  <FormikFields.DateRange name='dateRange' label='Date Range' isClearable />
                </div>
                <div className='tw-w-max'>
                  <FormikFields.DateTime name='date' label='Date' isClearable />
                </div>

                <div className='tw-flex tw-justify-end'>
                  <NewDesign.Button type='submit' className='tw-mr-1'>
                    Submit
                  </NewDesign.Button>
                  <NewDesign.Button variant='ghost' onClick={resetForm}>
                    <CommonIcons.Refresh size={SIZE_ICON} />
                    Reset
                  </NewDesign.Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>

      <div className='tw-mt-3'>
        <JSXCode
          code={`<Formik
    initialValues={{
        name: '',
        gender: '',
        level: [],
        group: 'groupA',
        dateRange: { from: '', to: '' },
        date: '',
    }}
    onSubmit={() => {}}
>
        {({ values, resetForm }) => {
          return (
            <Form>
                <NewDesign.Typography className='tw-text-2xl tw-mb-2' component='p'>
                  Form Example
                </NewDesign.Typography>

                <div className='tw-flex tw-flex-col tw-gap-2'>
                  <FormikFields.Input name='name' label='Name' placeholder='Name' />

                  <FormikFields.Select
                      name='gender'
                      placeholder='Select Gender'
                      label='Gender'
                      options={[
                        { label: 'Male', value: 'male' },
                        { label: 'Female', value: 'female' },
                      ]}
                      isClearable
                  />

                  <FormikFields.Select
                      name='level'
                      placeholder='Select Level'
                      label='Level'
                      options={[
                        { label: 'Senior', value: 'senior' },
                        { label: 'Middle', value: 'middle' },
                        { label: 'Junior', value: 'junior' },
                      ]}
                      isClearable
                      isMulti
                      closeMenuOnSelect={false}
                  />

                  <FormikFields.Checkbox name='isAdmin' label='Is Admin?' />

                  <NewDesign.Typography>Group: </NewDesign.Typography>
                  <div className='tw-flex tw-gap-2 default-border tw-p-2'>
                      <FormikFields.Radio name='group' label='Group A' valueRadio='groupA' />
                      <FormikFields.Radio name='group' label='Group B' valueRadio='groupB' />
                  </div>

                  <div className='tw-w-max'>
                      <FormikFields.DateRange name='dateRange' label='Date Range' isClearable />
                  </div>

                  <div className='tw-w-max'>
                      <FormikFields.DateTime name='date' label='Date' isClearable />
                  </div>

                  <div className='tw-flex tw-justify-end'>
                      <NewDesign.Button type='submit' className='tw-mr-1'>Submit</NewDesign.Button>
                      <NewDesign.Button variant='ghost' onClick={resetForm}><CommonIcons.Refresh size={SIZE_ICON} />Reset</NewDesign.Button>
                  </div>
                </div>
            </Form>
          );
        }}
</Formik>`}
        />
      </div>
    </div>
  );
};

export default TabForm;
